var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import style from './index.module.scss';
import ReactPaginate from 'react-paginate';
var cx = classnames.bind(style);
function Paginator(props) {
    var index = props.index, changeIndexHandler = props.changeIndexHandler, total = props.total;
    var pageChange = function (event) {
        changeIndexHandler(event.selected);
    };
    return (_jsx(_Fragment, { children: total > 1 && (_jsx("div", __assign({ className: cx('paginator') }, { children: _jsx(ReactPaginate, { initialPage: index, pageCount: total, pageRangeDisplayed: 1, marginPagesDisplayed: 2, onPageChange: pageChange }, void 0) }), void 0)) }, void 0));
}
export default Paginator;
